// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::after, ::before {
    box-sizing: border-box
}

body {
    font-family: Arial, Helvetica, sans-serif;
    color: #212529;
    background: #fff;
    line-height: 1.22;
    margin: 0;
    padding: 0
}

.container {
    width: 100%;
    position: relative;
    max-width: 1080px;
    margin: auto
}

.container-header {
    padding: 12px 16px 4px 16px;
    height: 46px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between
}

.container-article {
    padding: 3px 3px 0 3px;
    height: auto;
    display: flex;
    flex-flow: row wrap;
    align-items: stretch
}

.container-list {
    max-width: 1080px;
    padding: 0 3px 3px 3px;
    margin: auto
}

.logo p {
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    font-size: 15px;
    letter-spacing: .5em;
    font-weight: 700;
    color: #005bd1;
    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25)
}

header .logo p {
    line-height: 28px
}

.navigation {
    text-align: right;
    overflow: hidden
}

.navigation a {
    line-height: 28px;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    font-size: 13px;
    letter-spacing: .2em;
    margin-left: 20px;
    font-weight: 400;
    color: #aaa;
    float: right;
    display: block;
    text-decoration: none;
    transition: 0.2s
}

.navigation a:hover {
    color: #005bd1;
    transition: 0.2s
}

.navigation a.active {
    color: #005bd1;
    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25)
}

.navigation .icon {
    display: none
}

.w-50 {
    width: 50%
}

.w-100 {
    width: 100%
}

.items-box {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    align-content: flex-start
}

.items-box.sticky > .item-title {
    display: none
}

.item {
    padding: 4px
}

.item.item-hr {
    padding: 0
}

.w-100 .item-sm {
    width: 25%
}

.w-100 .item-lg {
    width: 50%
}

.w-50 .item-sm {
    width: 50%
}

.w-50 .item-lg {
    width: 100%
}

.item-hr {
    width: 100%
}

.item-p {
    width: 50%
}

.item-a {
    height: auto
}

.item-sm.item-t, .item-lg.item-t, .item-p.item-t {
    height: 330px
}

.item-hr.item-t {
    height: 135px;
    margin: 5px 0
}

.article {
    height: auto;
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 0 30px rgba(0, 0, 0, .1);
    padding: 12px
}

.article h1 {
    margin: 0;
    padding: 0;
    font-size: 24px;
    margin-bottom: 10px
}

.article p {
    font-family: Arial;
    font-weight: 400;
    line-height: 1.25
}

.article p img {
    width: 100% !important;
    height: auto !important;
    border-radius: 4px !important
}

.article > .item-info {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
    padding: 0 0 6px 0;
    margin: 0
}

.article > .item-info > .item-date {
    font-size: 11px;
    background: rgba(0, 0, 0, .03);
    padding: 4px;
    border-radius: 3px;
    color: #aaa
}

.article > .item-info > .item-category {
    font-size: 11px;
    background: rgba(0, 0, 0, .03);
    padding: 4px;
    border-radius: 3px;
    color: #aaa
}

.article > .item-recommended > .item-title {
    margin: 0;
    padding: 0;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 10px
}

.article > .item-recommended > .item-t.item-hr {
    margin: 0
}

.article > .item-recommended > .item-t.item-hr > .teaser {
    border-bottom: none
}

.article-preview {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative;
    box-shadow: 0 0 30px rgba(0, 0, 0, .23);
    border-radius: 5px;
    overflow: hidden;
    background: rgba(0, 0, 0, .4)
}

.article-preview a {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100
}

.article-preview .item-image {
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    display: flex;
    justify-content: center
}

.article-preview:hover .item-image img {
    transform: scale(1.06);
    transition: 0.65s
}

.article-preview:hover .item-overlay {
    background-image: linear-gradient(-180deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, .25) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)
}

.article-preview .item-image img {
    margin: 0;
    z-index: 10;
    padding: 0;
    height: 100%;
    transition: 0.65s;
    filter: contrast(115%);
    -webkit-filter: contrast(115%)
}

.article-preview .item-title {
    width: 100%;
    color: #fff;
    font-weight: 700;
    position: absolute;
    text-shadow: 1px 1px 4px black;
    bottom: 65px;
    left: 0;
    font-size: 24px;
    margin: 0;
    z-index: 40;
    padding: 14px
}

.article-preview .item-info {
    display: flex;
    color: #a0a0a0;
    position: absolute;
    text-shadow: 1px 1px 2px black;
    bottom: 45px;
    left: 0;
    font-size: 12px;
    z-index: 40;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
    padding: 14px;
    margin: 0
}

.article-preview .item-overlay-blur {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    overflow: hidden
}

.article-preview .item-overlay-blur img {
    z-index: 2;
    object-fit: cover;
    filter: blur(8px);
    -webkit-filter: blur(8px);
    margin: 0;
    padding: 0;
    margin-left: -3%;
    margin-top: -3%;
    height: 106%;
    width: 106%
}

.article-preview .item-category {
    z-index: 100;
    position: absolute;
    top: 10px;
    left: 10px;
    border-radius: 3px;
    padding: 5px;
    background: #005bd1;
    color: #fff;
    font-size: 10px;
    text-transform: uppercase
}

.article-preview .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)
}

.article-preview .item-button {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 15px 0;
    border-radius: 0 0 5px 5px;
    text-align: center;
    background: #005bd1;
    width: 100%;
    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25);
    color: #fff;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: .1em;
    font-weight: 700;
    z-index: 40;
    transition: 0.2s;
    transition-timing-function: cubic-bezier(.2, 1, .3, 1)
}

.article-preview .item-button:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0;
    transform: scale3d(.7, 1, 1);
    transition: transform 0.7s, opacity 0.7s;
    transition-timing-function: cubic-bezier(.2, 1, .3, 1);
    background: #0a6dee
}

.article-preview:hover .item-button:after {
    opacity: 1;
    transform: translate3d(0, 0, 0)
}

.item-sm > .teaser, .item-lg > .teaser {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative;
    box-shadow: 0 0 8px rgba(0, 0, 0, .3);
    border-radius: 5px;
    overflow: hidden;
    background: rgba(0, 0, 0, .4)
}

.item-hr > .teaser {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    float: left;
    background: #fff;
    padding: 8px 0;
    border-top: 1px solid #d3d3d3;
    border-bottom: 1px solid #d3d3d3
}

.item-sm > .teaser a, .item-lg > .teaser a, .item-hr > .teaser a {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100
}

.item-sm > .teaser .item-image, .item-lg > .teaser .item-image {
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
}

.item-hr > .teaser .item-image {
    float: left;
    height: 100%;
    width: 35%;
    margin: 0;
    margin-right: 0;
    overflow: hidden;
    z-index: 40;
    display: flex;
    justify-content: center
}

.item-sm > .teaser:hover .item-image img, .item-lg > .teaser:hover .item-image img, .item-hr > .teaser:hover .item-image img {
    transform: scale(1.06);
    transition: 0.65s
}

.item-sm > .teaser:hover .item-overlay, .item-lg > .teaser:hover .item-overlay {
    background-image: linear-gradient(-180deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, .25) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)
}

.item-sm > .teaser:hover .item-title, .item-lg > .teaser:hover .item-title, .item-hr > .teaser:hover .item-title {
    text-decoration: underline
}

.item-sm > .teaser .item-image img, .item-lg > .teaser .item-image img {
    margin: 0;
    z-index: 10;
    padding: 0;
    height: 100%;
    width: auto;
    min-width: 100%;
    object-fit: cover;
    transition: 0.65s;
    filter: contrast(115%);
    -webkit-filter: contrast(115%)
}

.item-hr > .teaser .item-image img {
    margin: 0;
    padding: 0;
    z-index: 40;
    width: 100%;
    height: auto;
    align-self: center;
    transition: 0.65s;
    filter: contrast(115%);
    -webkit-filter: contrast(115%)
}

.item-sm > .teaser .item-title, .item-lg > .teaser .item-title {
    width: 100%;
    color: #fff;
    font-weight: 700;
    position: absolute;
    text-shadow: 0 0 6px black;
    text-align: center;
    bottom: 0;
    left: 0;
    margin: 0;
    z-index: 40;
    padding: 18px 14px
}

.item-hr > .teaser .item-title {
    flex: 3 1;
    margin: 6px;
    color: #212529;
    align-self: center;
    justify-self: center;
    font-weight: 700;
    z-index: 50;
    line-height: 1.32
}

.item-sm > .teaser .item-title {
    font-size: 19px
}

.item-lg > .teaser .item-title {
    font-size: 24px
}

.item-hr > .teaser .item-title {
    font-size: 18px
}

.item-sm > .teaser .item-overlay-blur, .item-lg > .teaser .item-overlay-blur {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    overflow: hidden
}

.item-sm > .teaser .item-overlay-blur img, .item-lg > .teaser .item-overlay-blur img {
    z-index: 2;
    object-fit: cover;
    filter: blur(5px);
    -webkit-filter: blur(5px);
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    transform: scale(1.1);
}

.item-hr > .teaser .item-overlay-blur {
    display: none
}

.item-hr > .teaser .item-overlay-blur img {
    z-index: 2;
    object-fit: cover;
    filter: brightness(.45);
    -webkit-filter: brightness(.45);
    margin: 0;
    padding: 0;
    margin-left: -3%;
    margin-top: -3%;
    height: 120%;
    width: 120%
}

.item-sm > .teaser .item-category, .item-lg > .teaser .item-category {
    z-index: 100;
    position: absolute;
    top: 10px;
    left: 10px;
    border-radius: 3px;
    padding: 5px;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    font-size: 9px;
    letter-spacing: .05em;
    text-transform: uppercase
}

.item-hr > .teaser .item-category {
    z-index: 100;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    color: #005bd1;
    font-size: 10px;
    text-transform: uppercase
}

.item-sm > .teaser .item-date, .item-lg > .teaser .item-date {
    color: #212529;
    font-weight: 400;
    position: absolute;
    top: 10px;
    right: -200px;
    margin: 0;
    z-index: 40;
    font-size: 10px;
    padding: 4px;
    border-radius: 3px;
    background: rgba(255, 255, 255, .6)
}

.item-hr > .teaser .item-date {
    color: #a0a0a0;
    font-weight: 400;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0;
    z-index: 50;
    font-size: 11px;
    padding: 10px
}

.item-sm > .teaser .item-overlay, .item-lg > .teaser .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 30;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, .65) 80%, rgb(0, 0, 0, .75) 100%)
}

.item-hr > .teaser .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 10%, rgba(255, 255, 255, .2) 20%, rgba(255, 255, 255, .4) 25%, rgba(255, 255, 255, 1) 34%, rgb(255, 255, 255, 1) 40%, rgb(255, 255, 255, 0) 100%)
}

.teaser .item-button {
    display: none
}

.sticky {
    position: sticky;
    position: -webkit-sticky;
    top: 0
}

.hidden {
    display: none
}

.lazy-hidden {
    background: rgba(0, 0, 0, .6);
    transition: 0.15s
}

.loader {
    width: 100%;
    text-align: center;
    padding: 20px 0
}

.loader img {
    width: 40px;
    height: auto
}

.item-animate .item-image img {
    animation-name: scale;
    animation-duration: 2s;
    animation-iteration-count: 1
}

@keyframes scale {
    0% {
        transform: scale(1);
    }
    40% {
        transform: scale(1.15);
    }
    100% {
        transform: scale(1);
    }
}

@media screen and (max-width: 1080px) {
    .container {
        max-width: 900px
    }

    .w-50.left {
        width: 50%
    }

    .w-50.right {
        width: 50%
    }

    .w-100 .item-sm, .w-100 .item-lg {
        width: 33.3334%
    }

    .w-50 .item-sm, .w-50 .item-lg {
        width: 100%
    }

    .w-50 .item-sm.item-t, .w-50 .item-lg.item-t {
        height: 220px
    }

    .item-p.item-t {
        width: 66.6667%
    }

    .item-sm > .teaser .item-title {
        font-size: 20px
    }

    .item-lg > .teaser .item-title {
        font-size: 20px
    }

    .item-hr > .teaser .item-title {
        font-size: 17px
    }
}

@media screen and (max-width: 720px) {
    .logo p {
        font-size: 15px;
        letter-spacing: .3em
    }

    .navigation a {
        display: none
    }

    .navigation a.icon {
        float: right;
        display: block;
        font-size: 28px
    }

    .navigation.responsive {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        padding: 16px;
        background: #fff;
        z-index: 400;
        box-shadow: 0 0 150px rgba(0, 0, 0, .35)
    }

    .navigation.responsive .icon {
        position: absolute;
        right: 16px;
        top: 12px
    }

    .navigation.responsive a:not(.icon) {
        display: block;
        width: 100%;
        margin: 0;
        text-align: left
    }

    .sticky {
        position: relative
    }

    .items-box.sticky > .item-title {
        display: block;
        width: 100%;
        margin: 0;
        padding: 6px 12px;
        font-size: 24px;
        font-weight: 700
    }

    .w-50.left, .w-50.right {
        width: 100%
    }

    .w-100 .item-sm, .w-100 .item-lg, .w-50 .item-sm {
        width: 50%
    }

    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t, .w-100 .item-lg.item-t, .w-50 .item-lg.item-t {
        height: 280px
    }

    .item-hr > .teaser .item-title, .article-preview .item-title {
        font-size: 18px
    }

    .item-p.item-t {
        width: 100%;
        height: 280px
    }
}

@media screen and (max-width: 580px) {
    .w-100 .item-sm, .w-100 .item-lg, .w-50 .item-sm, .w-50 .item-lg {
        width: 100%
    }

    .w-100 .item-lg.item-t, .w-50 .item-lg.item-t, .item-p.item-t {
        height: 260px
    }

    .item-p > .article-preview > .item-title {
        font-size: 21px;
        line-height: 1.32;
        top: 0;
        left: 0;
        bottom: auto;
        right: auto
    }

    .item-p > .article-preview > .item-overlay {
        background-image: linear-gradient(0, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, .3) 20%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 60%, rgb(0, 0, 0, .5) 100%)
    }

    .item-p > .article-preview > .item-category {
        display: none
    }

    .item-p > .article-preview > .item-info > .item-date, .item-p > .article-preview > .item-info > .item-source {
        color: #fff
    }

    .item-hr > .teaser .item-title {
        font-size: 17px
    }

    .item-hr > .teaser .item-category, .item-hr > .teaser .item-date {
        display: none
    }

    .item-hr > .teaser .item-image {
        width: 40%
    }

    .item-hr > .teaser .item-overlay {
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 23%, rgba(255, 255, 255, .85) 35%, rgba(255, 255, 255, 1) 38%, rgb(255, 255, 255, 1) 45%, rgb(255, 255, 255, 0) 100%)
    }

    .item-hr > .teaser .item-image img {
        width: auto;
        height: 100%
    }

    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title {
        font-size: 22px
    }

    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t {
        height: 150px
    }

    .item-sm > .teaser {
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;
        float: left;
        background: transparent;
        padding: 0;
        box-shadow: 0 0 5px rgba(0, 0, 0, .3)
    }

    .item-sm > .teaser .item-image {
        float: left;
        height: 100%;
        width: 40%;
        margin: 0;
        margin-right: 20px;
        overflow: hidden;
        z-index: 40;
        display: flex;
        justify-content: center
    }

    .item-sm > .teaser .item-image img {
        margin: 0;
        padding: 0;
        z-index: 40;
        width: auto;
        height: 100%;
        align-self: center;
        transition: 0.65s;
        filter: contrast(115%);
        -webkit-filter: contrast(115%)
    }

    .item-sm > .teaser .item-title {
        flex: 3 1;
        margin: 15px;
        color: #212529;
        text-shadow: none;
        align-self: center;
        justify-self: center;
        font-weight: 700;
        z-index: 50;
        line-height: 1.32;
        width: auto;
        text-align: left;
        position: relative;
        font-size: 17px;
        padding: 0 6px
    }

    .item-sm > .teaser .item-category {
        display: none
    }

    .item-sm > .teaser .item-overlay {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 40;
        border-radius: 5px;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, .85)
    }
}

@media screen and (max-width: 380px) {
    .w-100 .item-lg.item-t, .w-50 .item-lg.item-t, .item-p.item-t {
        height: 240px
    }

    .item-hr > .teaser .item-title, .item-sm > .teaser .item-title {
        font-size: 16px;
        line-height: 1.25
    }

    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title, .item-p > .article-preview > .item-title, .item-lg > .teaser .item-title {
        font-size: 19px
    }

    .article-preview .item-button {
        padding: 14px 0;
        font-size: 13px
    }

    .article-preview .item-info {
        bottom: 40px
    }

    .item-lg > .teaser .item-title {
        padding: 14px
    }

    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t {
        height: 140px
    }
}

@media screen and (max-width: 330px) {
    .item-lg > .teaser .item-title {
        font-size: 18px
    }

    .item-sm > .teaser .item-title, .item-hr > .teaser .item-title {
        font-size: 15px
    }

    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title {
        font-size: 18px
    }
}
/* Добавляем стили для мобильного блока */
@media (min-width: 581px) {
    .mobile-top-news {
        display: none !important;
    }
}

@media (max-width: 580px) {
    .mobile-top-news {
        display: block;
        width: 100%;
    }
    .mobile-top-news .item {
        width: 100% !important;
        aspect-ratio: 1 / 1;
    }
}

/* Стили для мобильного блока верхних новостей */
.mobile-top-news {
    display: block;
    width: 100%;
    margin-bottom: 2px;
}

.mobile-top-news .item {
    width: 100% !important;
    height: 150px !important;
    margin-bottom: 0;
}

.mobile-top-news .teaser {
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    float: left;
    background: transparent;
    padding: 0;
    box-shadow: 0 0 5px rgba(0, 0, 0, .3);
}

.mobile-top-news .item-image {
    float: left;
    height: 100%;
    width: 40%;
    margin: 0;
    margin-right: 20px;
    overflow: hidden;
    z-index: 40;
    display: flex;
    justify-content: center;
}

.mobile-top-news .item-image img {
    margin: 0;
    padding: 0;
    z-index: 40;
    width: auto;
    height: 100%;
    align-self: center;
    transition: 0.65s;
    filter: contrast(115%);
    -webkit-filter: contrast(115%);
}

.mobile-top-news .item-title {
    flex: 3 1;
    margin: 15px;
    color: #212529;
    text-shadow: none;
    align-self: center;
    justify-self: center;
    font-weight: 700;
    z-index: 50;
    line-height: 1.32;
    width: auto;
    text-align: left;
    position: relative;
    font-size: 17px;
    padding: 0 6px;
}

.mobile-top-news .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 40;
    border-radius: 5px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .85);
}

.mobile-top-news .item-overlay-blur {
    display: none;
}

@media (min-width: 581px) {
    .mobile-top-news {
        display: none !important;
    }
}

@media (max-width: 580px) {
    .mobile-top-news {
        display: block !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,yCAAyC;IACzC,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,OAAO;IACP,eAAe;IACf,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,OAAO;IACP,eAAe;IAEf,WAAW;IACX,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAEhB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IAEV,4BAA4B;IAE5B,wCAAwC;IAExC,sDAAsD;IACtD;AACJ;;AAEA;IACI,UAAU;IAEV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,SAAO;IACP,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;IAC/B,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,cAAc;QACd;IACJ;;IAEA;QACI,eAAe;QACf,OAAO;QACP,MAAM;QACN,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,WAAW;QACX,SAAS;QACT,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,MAAM;QACN,OAAO;QACP,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,WAAW;QACX,uBAAuB;QACvB,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,SAAS;QACT,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb;IACJ;;IAEA;QACI,SAAS;QACT,UAAU;QACV,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,sBAAsB;QACtB;IACJ;;IAEA;QACI,SAAO;QACP,YAAY;QACZ,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,oBAAoB;QACpB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;AACA,yCAAyC;AACzC;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA,gDAAgD;AAChD;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["*, ::after, ::before {\n    box-sizing: border-box\n}\n\nbody {\n    font-family: Arial, Helvetica, sans-serif;\n    color: #212529;\n    background: #fff;\n    line-height: 1.22;\n    margin: 0;\n    padding: 0\n}\n\n.container {\n    width: 100%;\n    position: relative;\n    max-width: 1080px;\n    margin: auto\n}\n\n.container-header {\n    padding: 12px 16px 4px 16px;\n    height: 46px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between\n}\n\n.container-article {\n    padding: 3px 3px 0 3px;\n    height: auto;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: stretch\n}\n\n.container-list {\n    max-width: 1080px;\n    padding: 0 3px 3px 3px;\n    margin: auto\n}\n\n.logo p {\n    margin: 0;\n    padding: 0;\n    text-transform: uppercase;\n    font-size: 15px;\n    letter-spacing: .5em;\n    font-weight: 700;\n    color: #005bd1;\n    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25)\n}\n\nheader .logo p {\n    line-height: 28px\n}\n\n.navigation {\n    text-align: right;\n    overflow: hidden\n}\n\n.navigation a {\n    line-height: 28px;\n    margin: 0;\n    padding: 0;\n    text-transform: uppercase;\n    font-size: 13px;\n    letter-spacing: .2em;\n    margin-left: 20px;\n    font-weight: 400;\n    color: #aaa;\n    float: right;\n    display: block;\n    text-decoration: none;\n    transition: 0.2s\n}\n\n.navigation a:hover {\n    color: #005bd1;\n    transition: 0.2s\n}\n\n.navigation a.active {\n    color: #005bd1;\n    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25)\n}\n\n.navigation .icon {\n    display: none\n}\n\n.w-50 {\n    width: 50%\n}\n\n.w-100 {\n    width: 100%\n}\n\n.items-box {\n    display: flex;\n    flex-flow: row wrap;\n    align-items: flex-start;\n    align-content: flex-start\n}\n\n.items-box.sticky > .item-title {\n    display: none\n}\n\n.item {\n    padding: 4px\n}\n\n.item.item-hr {\n    padding: 0\n}\n\n.w-100 .item-sm {\n    width: 25%\n}\n\n.w-100 .item-lg {\n    width: 50%\n}\n\n.w-50 .item-sm {\n    width: 50%\n}\n\n.w-50 .item-lg {\n    width: 100%\n}\n\n.item-hr {\n    width: 100%\n}\n\n.item-p {\n    width: 50%\n}\n\n.item-a {\n    height: auto\n}\n\n.item-sm.item-t, .item-lg.item-t, .item-p.item-t {\n    height: 330px\n}\n\n.item-hr.item-t {\n    height: 135px;\n    margin: 5px 0\n}\n\n.article {\n    height: auto;\n    width: 100%;\n    border-radius: 5px;\n    box-shadow: 0 0 30px rgba(0, 0, 0, .1);\n    padding: 12px\n}\n\n.article h1 {\n    margin: 0;\n    padding: 0;\n    font-size: 24px;\n    margin-bottom: 10px\n}\n\n.article p {\n    font-family: Arial;\n    font-weight: 400;\n    line-height: 1.25\n}\n\n.article p img {\n    width: 100% !important;\n    height: auto !important;\n    border-radius: 4px !important\n}\n\n.article > .item-info {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0 0 6px 0;\n    margin: 0\n}\n\n.article > .item-info > .item-date {\n    font-size: 11px;\n    background: rgba(0, 0, 0, .03);\n    padding: 4px;\n    border-radius: 3px;\n    color: #aaa\n}\n\n.article > .item-info > .item-category {\n    font-size: 11px;\n    background: rgba(0, 0, 0, .03);\n    padding: 4px;\n    border-radius: 3px;\n    color: #aaa\n}\n\n.article > .item-recommended > .item-title {\n    margin: 0;\n    padding: 0;\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 10px\n}\n\n.article > .item-recommended > .item-t.item-hr {\n    margin: 0\n}\n\n.article > .item-recommended > .item-t.item-hr > .teaser {\n    border-bottom: none\n}\n\n.article-preview {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    position: relative;\n    box-shadow: 0 0 30px rgba(0, 0, 0, .23);\n    border-radius: 5px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, .4)\n}\n\n.article-preview a {\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100\n}\n\n.article-preview .item-image {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    z-index: 10;\n    display: flex;\n    justify-content: center\n}\n\n.article-preview:hover .item-image img {\n    transform: scale(1.06);\n    transition: 0.65s\n}\n\n.article-preview:hover .item-overlay {\n    background-image: linear-gradient(-180deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, .25) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)\n}\n\n.article-preview .item-image img {\n    margin: 0;\n    z-index: 10;\n    padding: 0;\n    height: 100%;\n    transition: 0.65s;\n    filter: contrast(115%);\n    -webkit-filter: contrast(115%)\n}\n\n.article-preview .item-title {\n    width: 100%;\n    color: #fff;\n    font-weight: 700;\n    position: absolute;\n    text-shadow: 1px 1px 4px black;\n    bottom: 65px;\n    left: 0;\n    font-size: 24px;\n    margin: 0;\n    z-index: 40;\n    padding: 14px\n}\n\n.article-preview .item-info {\n    display: flex;\n    color: #a0a0a0;\n    position: absolute;\n    text-shadow: 1px 1px 2px black;\n    bottom: 45px;\n    left: 0;\n    font-size: 12px;\n    margin: 0;\n    z-index: 40;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    width: 100%;\n    padding: 14px;\n    margin: 0\n}\n\n.article-preview .item-overlay-blur {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    overflow: hidden\n}\n\n.article-preview .item-overlay-blur img {\n    z-index: 2;\n    object-fit: cover;\n    filter: blur(8px);\n    -webkit-filter: blur(8px);\n    margin: 0;\n    padding: 0;\n    margin-left: -3%;\n    margin-top: -3%;\n    height: 106%;\n    width: 106%\n}\n\n.article-preview .item-category {\n    z-index: 100;\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    border-radius: 3px;\n    padding: 5px;\n    background: #005bd1;\n    color: #fff;\n    font-size: 10px;\n    text-transform: uppercase\n}\n\n.article-preview .item-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 30;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)\n}\n\n.article-preview .item-button {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    padding: 15px 0;\n    border-radius: 0 0 5px 5px;\n    text-align: center;\n    background: #005bd1;\n    width: 100%;\n    text-shadow: 1px 1px 10px rgba(0, 0, 0, .25);\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 14px;\n    letter-spacing: .1em;\n    font-weight: 700;\n    z-index: 40;\n    transition: 0.2s;\n    -webkit-transition-timing-function: cubic-bezier(.2, 1, .3, 1);\n    transition-timing-function: cubic-bezier(.2, 1, .3, 1)\n}\n\n.article-preview .item-button:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    opacity: 0;\n    -webkit-transform: scale3d(.7, 1, 1);\n    transform: scale3d(.7, 1, 1);\n    -webkit-transition: -webkit-transform 0.7s, opacity 0.7s;\n    transition: transform 0.7s, opacity 0.7s;\n    -webkit-transition-timing-function: cubic-bezier(.2, 1, .3, 1);\n    transition-timing-function: cubic-bezier(.2, 1, .3, 1);\n    background: #0a6dee\n}\n\n.article-preview:hover .item-button:after {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0)\n}\n\n.item-sm > .teaser, .item-lg > .teaser {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    position: relative;\n    box-shadow: 0 0 8px rgba(0, 0, 0, .3);\n    border-radius: 5px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, .4)\n}\n\n.item-hr > .teaser {\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    position: relative;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    float: left;\n    background: #fff;\n    padding: 8px 0;\n    border-top: 1px solid #d3d3d3;\n    border-bottom: 1px solid #d3d3d3\n}\n\n.item-sm > .teaser a, .item-lg > .teaser a, .item-hr > .teaser a {\n    width: 100%;\n    height: 100%;\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100\n}\n\n.item-sm > .teaser .item-image, .item-lg > .teaser .item-image {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    z-index: 10;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.item-hr > .teaser .item-image {\n    float: left;\n    height: 100%;\n    width: 35%;\n    margin: 0;\n    margin-right: 0;\n    overflow: hidden;\n    z-index: 40;\n    display: flex;\n    justify-content: center\n}\n\n.item-sm > .teaser:hover .item-image img, .item-lg > .teaser:hover .item-image img, .item-hr > .teaser:hover .item-image img {\n    transform: scale(1.06);\n    transition: 0.65s\n}\n\n.item-sm > .teaser:hover .item-overlay, .item-lg > .teaser:hover .item-overlay {\n    background-image: linear-gradient(-180deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, .25) 40%, rgba(0, 0, 0, .4) 60%, rgba(0, 0, 0, .7) 80%, rgb(0, 0, 0, .8) 100%)\n}\n\n.item-sm > .teaser:hover .item-title, .item-lg > .teaser:hover .item-title, .item-hr > .teaser:hover .item-title {\n    text-decoration: underline\n}\n\n.item-sm > .teaser .item-image img, .item-lg > .teaser .item-image img {\n    margin: 0;\n    z-index: 10;\n    padding: 0;\n    height: 100%;\n    width: auto;\n    min-width: 100%;\n    object-fit: cover;\n    transition: 0.65s;\n    filter: contrast(115%);\n    -webkit-filter: contrast(115%)\n}\n\n.item-hr > .teaser .item-image img {\n    margin: 0;\n    padding: 0;\n    z-index: 40;\n    width: 100%;\n    height: auto;\n    align-self: center;\n    transition: 0.65s;\n    filter: contrast(115%);\n    -webkit-filter: contrast(115%)\n}\n\n.item-sm > .teaser .item-title, .item-lg > .teaser .item-title {\n    width: 100%;\n    color: #fff;\n    font-weight: 700;\n    position: absolute;\n    text-shadow: 0 0 6px black;\n    text-align: center;\n    bottom: 0;\n    left: 0;\n    margin: 0;\n    z-index: 40;\n    padding: 18px 14px\n}\n\n.item-hr > .teaser .item-title {\n    flex: 3;\n    margin: 6px;\n    color: #212529;\n    align-self: center;\n    justify-self: center;\n    font-weight: 700;\n    z-index: 50;\n    line-height: 1.32\n}\n\n.item-sm > .teaser .item-title {\n    font-size: 19px\n}\n\n.item-lg > .teaser .item-title {\n    font-size: 24px\n}\n\n.item-hr > .teaser .item-title {\n    font-size: 18px\n}\n\n.item-sm > .teaser .item-overlay-blur, .item-lg > .teaser .item-overlay-blur {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    overflow: hidden\n}\n\n.item-sm > .teaser .item-overlay-blur img, .item-lg > .teaser .item-overlay-blur img {\n    z-index: 2;\n    object-fit: cover;\n    filter: blur(5px);\n    -webkit-filter: blur(5px);\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(1.1);\n}\n\n.item-hr > .teaser .item-overlay-blur {\n    display: none\n}\n\n.item-hr > .teaser .item-overlay-blur img {\n    z-index: 2;\n    object-fit: cover;\n    filter: brightness(.45);\n    -webkit-filter: brightness(.45);\n    margin: 0;\n    padding: 0;\n    margin-left: -3%;\n    margin-top: -3%;\n    height: 120%;\n    width: 120%\n}\n\n.item-sm > .teaser .item-category, .item-lg > .teaser .item-category {\n    z-index: 100;\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    border-radius: 3px;\n    padding: 5px;\n    background: rgba(0, 0, 0, .4);\n    color: #fff;\n    font-size: 9px;\n    letter-spacing: .05em;\n    text-transform: uppercase\n}\n\n.item-hr > .teaser .item-category {\n    z-index: 100;\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 10px;\n    color: #005bd1;\n    font-size: 10px;\n    text-transform: uppercase\n}\n\n.item-sm > .teaser .item-date, .item-lg > .teaser .item-date {\n    color: #212529;\n    font-weight: 400;\n    position: absolute;\n    top: 10px;\n    right: -200px;\n    margin: 0;\n    z-index: 40;\n    font-size: 10px;\n    padding: 4px;\n    border-radius: 3px;\n    background: rgba(255, 255, 255, .6)\n}\n\n.item-hr > .teaser .item-date {\n    color: #a0a0a0;\n    font-weight: 400;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    margin: 0;\n    z-index: 50;\n    font-size: 11px;\n    padding: 10px\n}\n\n.item-sm > .teaser .item-overlay, .item-lg > .teaser .item-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 30;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, .65) 80%, rgb(0, 0, 0, .75) 100%)\n}\n\n.item-hr > .teaser .item-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 50;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 10%, rgba(255, 255, 255, .2) 20%, rgba(255, 255, 255, .4) 25%, rgba(255, 255, 255, 1) 34%, rgb(255, 255, 255, 1) 40%, rgb(255, 255, 255, 0) 100%)\n}\n\n.teaser .item-button {\n    display: none\n}\n\n.sticky {\n    position: sticky;\n    position: -webkit-sticky;\n    top: 0\n}\n\n.hidden {\n    display: none\n}\n\n.lazy-hidden {\n    background: rgba(0, 0, 0, .6);\n    transition: 0.15s\n}\n\n.loader {\n    width: 100%;\n    text-align: center;\n    padding: 20px 0\n}\n\n.loader img {\n    width: 40px;\n    height: auto\n}\n\n.item-animate .item-image img {\n    animation-name: scale;\n    animation-duration: 2s;\n    animation-iteration-count: 1\n}\n\n@keyframes scale {\n    0% {\n        transform: scale(1);\n    }\n    40% {\n        transform: scale(1.15);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@media screen and (max-width: 1080px) {\n    .container {\n        max-width: 900px\n    }\n\n    .w-50.left {\n        width: 50%\n    }\n\n    .w-50.right {\n        width: 50%\n    }\n\n    .w-100 .item-sm, .w-100 .item-lg {\n        width: 33.3334%\n    }\n\n    .w-50 .item-sm, .w-50 .item-lg {\n        width: 100%\n    }\n\n    .w-50 .item-sm.item-t, .w-50 .item-lg.item-t {\n        height: 220px\n    }\n\n    .item-p.item-t {\n        width: 66.6667%\n    }\n\n    .item-sm > .teaser .item-title {\n        font-size: 20px\n    }\n\n    .item-lg > .teaser .item-title {\n        font-size: 20px\n    }\n\n    .item-hr > .teaser .item-title {\n        font-size: 17px\n    }\n}\n\n@media screen and (max-width: 720px) {\n    .logo p {\n        font-size: 15px;\n        letter-spacing: .3em\n    }\n\n    .navigation a {\n        display: none\n    }\n\n    .navigation a.icon {\n        float: right;\n        display: block;\n        font-size: 28px\n    }\n\n    .navigation.responsive {\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        padding: 16px;\n        background: #fff;\n        z-index: 400;\n        box-shadow: 0 0 150px rgba(0, 0, 0, .35)\n    }\n\n    .navigation.responsive .icon {\n        position: absolute;\n        right: 16px;\n        top: 12px\n    }\n\n    .navigation.responsive a:not(.icon) {\n        display: block;\n        width: 100%;\n        margin: 0;\n        text-align: left\n    }\n\n    .sticky {\n        position: relative\n    }\n\n    .items-box.sticky > .item-title {\n        display: block;\n        width: 100%;\n        margin: 0;\n        padding: 6px 12px;\n        font-size: 24px;\n        font-weight: 700\n    }\n\n    .w-50.left, .w-50.right {\n        width: 100%\n    }\n\n    .w-100 .item-sm, .w-100 .item-lg, .w-50 .item-sm {\n        width: 50%\n    }\n\n    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t, .w-100 .item-lg.item-t, .w-50 .item-lg.item-t {\n        height: 280px\n    }\n\n    .item-hr > .teaser .item-title, .article-preview .item-title {\n        font-size: 18px\n    }\n\n    .item-p.item-t {\n        width: 100%;\n        height: 280px\n    }\n}\n\n@media screen and (max-width: 580px) {\n    .w-100 .item-sm, .w-100 .item-lg, .w-50 .item-sm, .w-50 .item-lg {\n        width: 100%\n    }\n\n    .w-100 .item-lg.item-t, .w-50 .item-lg.item-t, .item-p.item-t {\n        height: 260px\n    }\n\n    .item-p > .article-preview > .item-title {\n        font-size: 21px;\n        line-height: 1.32;\n        top: 0;\n        left: 0;\n        bottom: auto;\n        right: auto\n    }\n\n    .item-p > .article-preview > .item-overlay {\n        background-image: linear-gradient(0, rgba(0, 0, 0, .7) 0%, rgba(0, 0, 0, .3) 20%, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0) 60%, rgb(0, 0, 0, .5) 100%)\n    }\n\n    .item-p > .article-preview > .item-category {\n        display: none\n    }\n\n    .item-p > .article-preview > .item-info > .item-date, .item-p > .article-preview > .item-info > .item-source {\n        color: #fff\n    }\n\n    .item-hr > .teaser .item-title {\n        font-size: 17px\n    }\n\n    .item-hr > .teaser .item-category, .item-hr > .teaser .item-date {\n        display: none\n    }\n\n    .item-hr > .teaser .item-image {\n        width: 40%\n    }\n\n    .item-hr > .teaser .item-overlay {\n        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 23%, rgba(255, 255, 255, .85) 35%, rgba(255, 255, 255, 1) 38%, rgb(255, 255, 255, 1) 45%, rgb(255, 255, 255, 0) 100%)\n    }\n\n    .item-hr > .teaser .item-image img {\n        width: auto;\n        height: 100%\n    }\n\n    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title {\n        font-size: 22px\n    }\n\n    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t {\n        height: 150px\n    }\n\n    .item-sm > .teaser {\n        display: flex;\n        flex-direction: row;\n        box-sizing: border-box;\n        position: relative;\n        height: 100%;\n        width: 100%;\n        overflow: hidden;\n        float: left;\n        background: transparent;\n        padding: 0;\n        box-shadow: 0 0 5px rgba(0, 0, 0, .3)\n    }\n\n    .item-sm > .teaser .item-image {\n        float: left;\n        height: 100%;\n        width: 40%;\n        margin: 0;\n        margin-right: 20px;\n        overflow: hidden;\n        z-index: 40;\n        display: flex;\n        justify-content: center\n    }\n\n    .item-sm > .teaser .item-image img {\n        margin: 0;\n        padding: 0;\n        z-index: 40;\n        width: auto;\n        height: 100%;\n        align-self: center;\n        transition: 0.65s;\n        filter: contrast(115%);\n        -webkit-filter: contrast(115%)\n    }\n\n    .item-sm > .teaser .item-title {\n        flex: 3;\n        margin: 15px;\n        color: #212529;\n        text-shadow: none;\n        align-self: center;\n        justify-self: center;\n        font-weight: 700;\n        z-index: 50;\n        line-height: 1.32;\n        width: auto;\n        text-align: left;\n        position: relative;\n        font-size: 17px;\n        padding: 0 6px\n    }\n\n    .item-sm > .teaser .item-category {\n        display: none\n    }\n\n    .item-sm > .teaser .item-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 40;\n        border-radius: 5px;\n        width: 100%;\n        height: 100%;\n        background: rgba(255, 255, 255, .85)\n    }\n}\n\n@media screen and (max-width: 380px) {\n    .w-100 .item-lg.item-t, .w-50 .item-lg.item-t, .item-p.item-t {\n        height: 240px\n    }\n\n    .item-hr > .teaser .item-title, .item-sm > .teaser .item-title {\n        font-size: 16px;\n        line-height: 1.25\n    }\n\n    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title, .item-p > .article-preview > .item-title, .item-lg > .teaser .item-title {\n        font-size: 19px\n    }\n\n    .article-preview .item-button {\n        padding: 14px 0;\n        font-size: 13px\n    }\n\n    .article-preview .item-info {\n        bottom: 40px\n    }\n\n    .item-lg > .teaser .item-title {\n        padding: 14px\n    }\n\n    .w-50 .item-sm.item-t, .w-100 .item-sm.item-t {\n        height: 140px\n    }\n}\n\n@media screen and (max-width: 330px) {\n    .item-lg > .teaser .item-title {\n        font-size: 18px\n    }\n\n    .item-sm > .teaser .item-title, .item-hr > .teaser .item-title {\n        font-size: 15px\n    }\n\n    .article h1, .article > .item-recommended > .item-title, .items-box.sticky > .item-title {\n        font-size: 18px\n    }\n}\n/* Добавляем стили для мобильного блока */\n@media (min-width: 581px) {\n    .mobile-top-news {\n        display: none !important;\n    }\n}\n\n@media (max-width: 580px) {\n    .mobile-top-news {\n        display: block;\n        width: 100%;\n    }\n    .mobile-top-news .item {\n        width: 100% !important;\n        aspect-ratio: 1 / 1;\n    }\n}\n\n/* Стили для мобильного блока верхних новостей */\n.mobile-top-news {\n    display: block;\n    width: 100%;\n    margin-bottom: 2px;\n}\n\n.mobile-top-news .item {\n    width: 100% !important;\n    height: 150px !important;\n    margin-bottom: 0;\n}\n\n.mobile-top-news .teaser {\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n    position: relative;\n    overflow: hidden;\n    float: left;\n    background: transparent;\n    padding: 0;\n    box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n\n.mobile-top-news .item-image {\n    float: left;\n    height: 100%;\n    width: 40%;\n    margin: 0;\n    margin-right: 20px;\n    overflow: hidden;\n    z-index: 40;\n    display: flex;\n    justify-content: center;\n}\n\n.mobile-top-news .item-image img {\n    margin: 0;\n    padding: 0;\n    z-index: 40;\n    width: auto;\n    height: 100%;\n    align-self: center;\n    transition: 0.65s;\n    filter: contrast(115%);\n    -webkit-filter: contrast(115%);\n}\n\n.mobile-top-news .item-title {\n    flex: 3;\n    margin: 15px;\n    color: #212529;\n    text-shadow: none;\n    align-self: center;\n    justify-self: center;\n    font-weight: 700;\n    z-index: 50;\n    line-height: 1.32;\n    width: auto;\n    text-align: left;\n    position: relative;\n    font-size: 17px;\n    padding: 0 6px;\n}\n\n.mobile-top-news .item-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 40;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, .85);\n}\n\n.mobile-top-news .item-overlay-blur {\n    display: none;\n}\n\n@media (min-width: 581px) {\n    .mobile-top-news {\n        display: none !important;\n    }\n}\n\n@media (max-width: 580px) {\n    .mobile-top-news {\n        display: block !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
